import { Link } from 'react-router-dom';
import { ROUTES } from '@traction/shared';
import { Target, Zap, Users, Shield } from 'lucide-react';

const values = [
  {
    icon: Target,
    title: 'Founder-First',
    description: 'Built by founders, for founders. We understand the hustle of early-stage growth.',
  },
  {
    icon: Zap,
    title: 'AI-Powered',
    description: 'Leverage cutting-edge AI to find and engage prospects while you focus on building.',
  },
  {
    icon: Users,
    title: 'Human-in-the-Loop',
    description: 'AI drafts, you decide. Maintain authentic relationships with full control.',
  },
  {
    icon: Shield,
    title: 'Privacy-First',
    description: 'Your data stays yours. Enterprise-grade security and compliance built-in.',
  },
];

export function AboutPage() {
  return (
    <div className="py-12 bg-cacao-dark">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="font-heading text-xl font-semibold text-[#F5F5F5]">About Traction Bee</h1>
          <p className="mt-2 text-sm text-cacao-muted">
            Your AI-powered growth engine for early-stage startups
          </p>
        </div>

        <div className="mt-10">
          <h2 className="text-sm font-medium text-cacao-muted uppercase tracking-wide">Our Mission</h2>
          <p className="mt-3 text-sm text-cacao-muted leading-relaxed">
            Traction Bee was born from a simple observation: pre-revenue founders spend too much time
            on manual prospecting instead of building their product. We believe AI should handle
            the heavy lifting of lead generation and outreach, while founders maintain authentic
            human connections.
          </p>
          <p className="mt-3 text-sm text-cacao-muted leading-relaxed">
            Our platform combines autonomous AI agents with a
            human-in-the-loop approach. Every morning, you wake up to 3 high-quality leads with
            personalized emails ready to send from your own Gmail. You review, tweak if needed,
            and send with one click.
          </p>
        </div>

        <div className="mt-10">
          <h2 className="text-sm font-medium text-cacao-muted uppercase tracking-wide">Our Values</h2>
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((value) => (
              <div key={value.title} className="rounded-lg border border-cacao-dark-tertiary bg-cacao-dark-secondary p-4">
                <value.icon className="h-4 w-4 text-cacao-gold" />
                <h3 className="mt-2.5 text-sm font-medium text-[#F5F5F5]">{value.title}</h3>
                <p className="mt-1 text-xs text-cacao-muted">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 rounded-lg bg-cacao-dark-secondary border border-cacao-dark-tertiary p-6 text-center">
          <h2 className="font-heading text-sm font-medium text-[#F5F5F5]">Ready to grow?</h2>
          <p className="mt-1 text-xs text-cacao-muted">
            Join founders who are growing smarter with AI-powered outreach.
          </p>
          <Link
            to={ROUTES.SIGNUP}
            className="mt-4 inline-block rounded-md bg-cacao-gold px-4 py-2 text-sm font-medium text-cacao-dark hover:bg-cacao-gold-hover transition-colors"
          >
            Start free trial
          </Link>
        </div>
      </div>
    </div>
  );
}
